const RETURN_ROOTS = new Set([
  'dashboard', 'activity', 'history', 'reports', 'debts', 'cashback',
  'operations', 'transactions', 'limits', 'archive', 'account', 'invite',
  'categories', 'budgets',
]);

export function safeReturnTo(value: string | null): string {
  if (value === null || !value.startsWith('/') || /[\\\s#]/u.test(value)) return '/dashboard';
  const pathname = value.split('?')[0];
  if (!RETURN_ROOTS.has(pathname.split('/')[1]) || /%|\/\.\.?\//u.test(pathname)) return '/dashboard';
  return value;
}
